'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import InstagramEmbed from 'dyzio-shared-components/lib/components/dyzio-instagram-embed';

var imgStyle = {
  margin: '0px auto',
  height: 380,
  cursor: 'pointer',
  'object-fit': 'cover',
  'object-position': 'top'
};

var width100 = {
  width: '100%',
  height: 380,
  cursor: 'pointer',
  'object-fit': 'cover',
  'object-position': 'top'
};

var DyzioInstagramEmbed = function (_Component) {
  (0, _inherits3.default)(DyzioInstagramEmbed, _Component);

  function DyzioInstagramEmbed() {
    (0, _classCallCheck3.default)(this, DyzioInstagramEmbed);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DyzioInstagramEmbed.__proto__ || (0, _getPrototypeOf2.default)(DyzioInstagramEmbed)).call(this));

    _this.state = {
      savedThumbnailUrl: '',
      error: false,
      loading: true
    };
    return _this;
  }

  (0, _createClass3.default)(DyzioInstagramEmbed, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var assetId, _ref2, status, data, _$get, savedThumbnailUrl;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                assetId = this.props.assetId;
                _context.prev = 1;
                _context.next = 4;
                return (0, _axios2.default)('https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer/instagram/embed/' + assetId + '/data');

              case 4:
                _ref2 = _context.sent;
                status = _ref2.status;
                data = _ref2.data;


                if (_lodash2.default.isEqual(status, 200)) {
                  console.log('SUCCESS');
                  _$get = _lodash2.default.get(data, 'data'), savedThumbnailUrl = _$get.savedThumbnailUrl;

                  this.setState({
                    savedThumbnailUrl: savedThumbnailUrl,
                    loading: false
                  });
                } else {
                  this.setState({
                    error: true,
                    loading: false
                  });
                }
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);
                this.setState({
                  error: true,
                  loading: false
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 10]]);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          savedThumbnailUrl = _state.savedThumbnailUrl,
          error = _state.error,
          loading = _state.loading;
      var _props = this.props,
          assetId = _props.assetId,
          maxWidth = _props.maxWidth;


      console.log('savedThumbnailUrl', savedThumbnailUrl);
      if (error) {
        return _react2.default.createElement(_semanticUiReact.Message, {
          header: 'Error Fetching Asset',
          content: 'Please check the url and retry.'
        });
      }

      if (loading) {
        return _react2.default.createElement(_semanticUiReact.Message, {
          header: 'Loading Asset'
        });
      }

      if (savedThumbnailUrl) {
        return _react2.default.createElement(_semanticUiReact.Image, {
          size: 'large',
          style: maxWidth ? width100 : imgStyle,
          src: savedThumbnailUrl,
          onClick: function onClick() {
            return window.open('https://instagram.com/p/' + assetId, '_blank');
          }
        });
      }

      return _react2.default.createElement(_semanticUiReact.Message, {
        header: 'Error Fetching Asset',
        content: 'Please check the url and retry.'
      });
    }
  }]);
  return DyzioInstagramEmbed;
}(_react.Component);

DyzioInstagramEmbed.propTypes = {
  assetId: _propTypes2.default.string.isRequired
};

DyzioInstagramEmbed.defaultProps = {
  maxWidth: false
};

exports.default = DyzioInstagramEmbed;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/dyzio-instagram-embed/index.js
 ** module id = 2553
 ** module chunks = 0
 **/